import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { QuestelEntity } from '@/models/Companies/QuestelEntity';

export class CompanyService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, "/api");
  }

  public async getQuestelEntityList(): Promise<Array<QuestelEntity>> {
    return await this.client.get<Array<QuestelEntity>>(`/v1/company/QuestelEntityList`);
  }
}